import React from "react";

/**
 * EyeIcon component function.
 *
 * @param {string} cls - class name for the SVG
 * @return {JSX.Element} SVG element
 */
export const EyeIcon = ({ cls = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      className={cls}
    >
      <g clipPath="url(#clip0_2821_38145)">
        <path
          d="M15.514 6.33355C14.48 4.64955 12.128 1.82422 8 1.82422C3.872 1.82422 1.52 4.64955 0.486004 6.33355C0.166356 6.85056 -0.00296021 7.44638 -0.00296021 8.05422C-0.00296021 8.66206 0.166356 9.25788 0.486004 9.77489C1.52 11.4589 3.872 14.2842 8 14.2842C12.128 14.2842 14.48 11.4589 15.514 9.77489C15.8337 9.25788 16.003 8.66206 16.003 8.05422C16.003 7.44638 15.8337 6.85056 15.514 6.33355ZM14.3773 9.07689C13.4893 10.5209 11.4793 12.9509 8 12.9509C4.52067 12.9509 2.51067 10.5209 1.62267 9.07689C1.43276 8.76958 1.33217 8.41547 1.33217 8.05422C1.33217 7.69297 1.43276 7.33886 1.62267 7.03155C2.51067 5.58755 4.52067 3.15755 8 3.15755C11.4793 3.15755 13.4893 5.58489 14.3773 7.03155C14.5672 7.33886 14.6678 7.69297 14.6678 8.05422C14.6678 8.41547 14.5672 8.76958 14.3773 9.07689Z"
          fill="currentColor"
        />
        <path
          d="M8.00001 4.72168C7.34074 4.72168 6.69627 4.91718 6.14811 5.28345C5.59994 5.64972 5.1727 6.17031 4.92041 6.7794C4.66812 7.38849 4.6021 8.05871 4.73072 8.70531C4.85934 9.35192 5.17681 9.94586 5.64298 10.412C6.10916 10.8782 6.7031 11.1957 7.34971 11.3243C7.99631 11.4529 8.66653 11.3869 9.27562 11.1346C9.88471 10.8823 10.4053 10.4551 10.7716 9.90691C11.1378 9.35875 11.3333 8.71428 11.3333 8.05501C11.3323 7.17128 10.9808 6.32405 10.3559 5.69916C9.73097 5.07427 8.88374 4.72274 8.00001 4.72168ZM8.00001 10.055C7.60444 10.055 7.21776 9.93772 6.88887 9.71795C6.55997 9.49819 6.30362 9.18583 6.15225 8.82038C6.00087 8.45493 5.96127 8.05279 6.03844 7.66483C6.11561 7.27687 6.30609 6.9205 6.58579 6.6408C6.8655 6.36109 7.22186 6.17061 7.60983 6.09344C7.99779 6.01627 8.39992 6.05588 8.76537 6.20725C9.13083 6.35863 9.44318 6.61497 9.66295 6.94387C9.88271 7.27277 10 7.65945 10 8.05501C10 8.58545 9.78929 9.09415 9.41422 9.46923C9.03915 9.8443 8.53044 10.055 8.00001 10.055Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2821_38145">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.0546875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
